<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'
    import {AUTH_EVENT, EventBus} from '@/utils/event-bus'

    @Component
    export class SearchPageAuthMixin extends Vue {
        mounted() {
            EventBus.$on(AUTH_EVENT, this.search)
        }

        beforeUnmount() {
            EventBus.$off(AUTH_EVENT, this.search)
        }
    }

    export default SearchPageAuthMixin
</script>
